// extracted by mini-css-extract-plugin
module.exports = {"donation":"kn","donationIcon":"ko","donationTitle":"kp"};